export default __webpack_public_path__ + "static/media/030-avalanche.dbb45f7b.svg";